export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "639dcf160amshd5b7027b04da958p102233jsneca5e1dc030a",
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};
export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "984b7a384d6fce0a291c43739fc71d22";
